export default __webpack_public_path__ + "static/media/precincts2012.7815bd92.txt";